module.exports = __webpack_public_path__ + "static/media/unfollow.835ee908.svg";